import React, { Component } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import LoadingOverlay from 'react-loading-overlay'
import MoonLoader from "react-spinners/MoonLoader";
import App from './app';
import Login from '@/views/Login';

const Pages = props => {
  const {
    user,
    loading: {
      status
    }
  } = props;

  return (
    <LoadingOverlay
      active={ status }
      spinner={ <MoonLoader /> }
      styles={{
        wrapper: (base) => ({
          ...base,
          height: '100vh',
        }),
        overlay: (base) => ({
          ...base,
          position: 'fixed'
        })
      }}
    >
      <Router>
        <Switch>
          <Route
            path='/login'
            render={ () => {
              const isLogin = user.id
              return ( isLogin ?
                  <Redirect to='/' />
                :
                  <Login />
              );
            }}
          />
          <Route render={ () => <App /> } />
        </Switch>
      </Router>
    </LoadingOverlay>
  );
}

const mapStateToProps = ({ loading, user }, owns) => ({
  user,
  loading,
  ...owns
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pages);
